import React, { useEffect, useState, useRef } from "react";
import {
  Box,
  Button,
  FormControl,
  Input,
  InputGroup,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Stack,
  Text,
  useDisclosure
} from "@chakra-ui/react";


export default function PrecedenceForm({
  precedenceInput, 
precedence_default}) {
  return (<FormControl >
    <Input
      pr="4.5rem"
      type="text"
      name="task"
      defaultValue={precedence_default}
      placeholder="Before:"
      aria-label="Add precedence"
      ref={precedenceInput}
    />
  </FormControl>)
}